module.exports = __webpack_public_path__ + "img/certificado1.fe67181b.png";